import moment from 'moment';
import H_time from "@/helpers/time";

export default {
  modelName: 'll_broadcast',
  label: 'ESGoal快報',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '快報主旨',
          rules: 'required',
          maxlength: 100,
        },
        content: {
          type: 'editor',
          label: '快報內容',
          rules: 'required',
          maxlength: 5000,
          getRules: function() {
            const keyword = "<p></p>"
            return `is_not:${keyword}`;
          },
          rulesErrorMessage: function(originData) {
            const keyword = "<p></p>"
            if (originData.content === keyword) {
              return "請填入快報內容"
            }
            return null;
          },
        },
      },
    },
    attaches: {
      type: 'files',
      label: '附件',
      uploadUrl: '/ll_broadcast/attach/',
    },
    name: {
      type: 'text',
      label: '快報主旨',
      rules: 'required',
      maxlength: 100,
    },
    content: {
      type: 'editor',
      label: '快報內容',
      rules: 'required',
      maxlength: 5000,
      getRules: function() {
        const keyword = "<p></p>"
        return `is_not:${keyword}`;
      },
      rulesErrorMessage: function(originData) {
        const keyword = "<p></p>"
        if (originData.content === keyword) {
          return "請填入快報內容"
        }
        return null;
      },
    },
    announce_at: {
      type: 'datetime',
      label: '發布時間',
      rules: 'required',
      format: 'YYYY-MM-DD HH',
      disabledDate: (date) => date < new Date(new Date().setHours(0, 0, 0, 0)),
      disabledTime: (date) => date < moment().toDate(),
      defaultValue: H_time.getNextOnTheHour(),
    },
    areas: {
      label: '適用地區',
      type: 'multi-layer',
      rules: 'required',
      modelName: 'areas',
      getUrl: 'area',
      requiredField: 'area_sections',
      multiple: true,
      layersSetting: {
        modelName: 'area_sections',
        requiredFieldKey: 'area_sections',
        search: true,
      },
      fields: {
        modelName: 'area',
        requiredField: 'area_sections',
        layersSetting: {
          modelName: 'area_sections',
          requiredFieldKey: 'area_sections',
          search: true,
        },
      }
    },
    area_sections: {
      label: '適用子地區',
      type: 'hasMany',
    },
    system_classes: {
      label: '領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_class',
      placeholder: '選擇領域分類',
      rules: 'required',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText(data) {
        let _text = data.name;
        if (data.area && data.area.name) {
          _text += `(${data.area.name})`;
        }
        return _text;
      },
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_classes',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_classes',
      label: '子領域',
      type: 'hasMany',
      textKey: 'name',
      rules: 'required',
      modelName: 'system_subclass',
      getText(data) {
        let _text = data.name;
        if (data.area && data.area.name) {
          _text += `(${data.area.name})`;
        }
        return _text;
      },
    },
    industry_categories: {
      label: '適用產業別',
      type: 'multi-layer',
      textKey: 'name',
      modelName: 'industry_categories',
      getUrl: 'industry_category',
      multiple: true,
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText(data) {
        let _text = data.name;
        if (data.area && data.area.name) {
          _text += `(${data.area.name})`;
        }
        return _text;
      },
      fields: {
        modelName: 'industry_categories',
        getUrl: 'industry_category',
        conditionKeys: [
          {
            fieldName: 'areas',
            conditionName: 'area',
            type: 'array',
          },
        ],
      }
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
  },
};
